import React, { Component, Fragment } from "react";
import api from "../../../../../services/api";
import Select from "../../Relatorio1/Select";
import Radio from "../../Relatorio1/Radio";
import { Link } from "react-router-dom";

import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';

import utils from "../../../../../utils/utilsProducaoSTI";
import AnualV2 from "../../Anual_v2";

export default class Index extends Component {

    constructor(props) {
        super(props);

        this.state = {
            aplicationName: "Módulo de Metas",
            dados: {},
            mesSelecionado: "janeiro",
            isAcumulado: false,
            radioChecked: "mes"
        }
    }

    async componentDidMount() {
        await this.getDados();
    }

    async componentDidUpdate(prevProps, prevState) {
        if (prevState.isAcumulado !== this.state.isAcumulado) {
            await this.getDados();
        }
    }

    getDados = async (isAcumulado) => {

        let url = this.state.isAcumulado ? "/sti/consulta?tipo=acumulado" : "/sti/consulta?tipo=mes";
        let dados = await api.get(url);
        dados = dados.data.dados;

        this.setState({ dados });

    }

    selectMes = (event) => {
        this.setState({ mesSelecionado: event.target.value })
    }

    onChange = async (event) => {
        let isAcumulado = event.target.value === "acumulado" ? true : false;
        this.setState({ isAcumulado, radioChecked: event.target.value })
    }

    identificaLinhadeAtuacao = (categoria) => {

        let linha;
        switch(categoria) {
            case "Consultoria para Atendimento de Legislações, Normas e Regulamentos Técnicos":
            case "Consultoria em Processos Produtivos":
                linha = "Consultoria em Tecnologia";
                break;
            case "Calibração":
            case "Ensaios":
                linha = "Metrologia";
                break;
            case "Pesquisa, Desenvolvimento e Inovação de Produto":
            case "Pesquisa, Desenvolvimento e Inovação de Processo":
                linha = "Pesquisa, Desenvolvimento e Inovação";
                break;
            case "Consultoria em Gestão Empresarial":
                linha = "Serviços Complementares";
                break;
            case "Serviços Operacionais":
                linha = "Serviços Técnicos Especializados";
                break;

        }
        
        return linha;

    }

    formataJSONcomSomatorio = () => {

        let dados = JSON.parse(JSON.stringify(this.state.dados));
        
        let novosDados = JSON.parse(JSON.stringify(dados));

        Object.keys(dados).map((mes, i) => {
            
            dados[mes].map((unidade, j) => {

                let t = novosDados[mes][novosDados[mes].findIndex((v) => v.unidade === unidade.unidade)];
                
                Object.keys(unidade.modalidades).map((categoria, k) => {
                    
                    let linha = this.identificaLinhadeAtuacao(categoria);
                    
                    if(!t.modalidades.hasOwnProperty(linha)) {
                        t.modalidades[linha] = unidade.modalidades[categoria];
                    }
                    else {
                        Object.keys(t.modalidades[linha]).map((indicador, ind) => {
                            t.modalidades[linha][indicador] += unidade.modalidades[categoria][indicador];
                        })
                    }

                });

            });

        });

        return novosDados;

    }

    verificaValorTotalCategoria = (linhaAtuacao, valor) => {
        let valorTotalColuna = 0;
        if(valor.modalidades.hasOwnProperty(linhaAtuacao)) {
            if(linhaAtuacao === "Consultoria em Tecnologia") {
                valorTotalColuna = valor.modalidades[linhaAtuacao]["horasTecnicas"];
            }
            else if(linhaAtuacao === "Metrologia") {
                valorTotalColuna = null
            }
            else if(linhaAtuacao === "Pesquisa, Desenvolvimento e Inovação") {
                valorTotalColuna = valor.modalidades[linhaAtuacao]["horasTecnicas"];
            }
            else if(linhaAtuacao === "Serviços Técnicos Especializados") {
                valorTotalColuna = valor.modalidades[linhaAtuacao]["numeroAtendimento"];
            }
        }
        return valorTotalColuna;
    }

    // formatar json do realizado para ficar igual a meta
    transformaJSONRealizados = (dados, meses) => {

        let realizados = dados;
        // cria novo objeto vazio
        let obj = {}

        // constroi no json formatado com valores zerados
        // itera sobre o array de 12 meses
        Object.keys(realizados).map((mes, i) => {
            // intera sobre o array das unidades
            realizados[mes].map((unidade, j) => {
                // verifica se o novo objeto (obj) possui a propriedade da unidade
                let nomeUnidade = unidade.unidade;
                // se não existir a propriedade, adiciona uma propridade modalidade vazia
                if(!obj.hasOwnProperty(nomeUnidade)) {
                    obj[nomeUnidade] = { unidade: nomeUnidade, modalidades: {} }
                    Object.keys(unidade.modalidades).map((categoria, k) => {
                        
                        if(!obj[nomeUnidade].modalidades.hasOwnProperty(categoria)) {
                            let objindicadores = {
                                calibracoes:       new Array(12).fill(0),
                                ensaios:           new Array(12).fill(0),
                                horasTecnicas:     new Array(12).fill(0),
                                numeroAtendimento: new Array(12).fill(0),
                                relatoriosELaudos: new Array(12).fill(0)
                            }
                            obj[nomeUnidade].modalidades[categoria] = objindicadores;
                        }

                    });
                }
            });
        });

        // itera sobre o array e preenche os valores mensais
        Object.keys(realizados).map((mes, i) => {
            realizados[mes].map((unidade, j) => {
                let nomeUnidade = unidade.unidade;
                Object.keys(unidade.modalidades).map((categoria, k) => {
                    Object.keys(unidade.modalidades[categoria]).map((indicador, l) => {
                        obj[nomeUnidade].modalidades[categoria][indicador][meses.indexOf(mes)] = unidade.modalidades[categoria][indicador]
                    });
                });

            });
        });

        return obj;

    }

    render() {

        let { dados, mesSelecionado, radioChecked } = this.state;
        let totais;
        let linhaAtuacao = [
            "Consultoria em Tecnologia",
            "Metrologia",
            "Pesquisa, Desenvolvimento e Inovação",
            "Serviços Técnicos Especializados",
            "Serviços Complementares"
        ]

        dados = this.formataJSONcomSomatorio();
        let meses = ["janeiro", "fevereiro", "marco", "abril", "maio", "junho", "julho", "agosto", "setembro", "outubro", "novembro", "dezembro"];
        let dadosTransformados = this.transformaJSONRealizados(dados, meses);

        return (
            <Fragment>

                <div class="card">
                    <div class="card-header">
                        Opções
                    </div>
                    <div class="card-body">

                        <Select selectMes={this.selectMes} selecionado={mesSelecionado} />
                        {/* <Radio onChange={this.onChange} radioChecked={radioChecked} /> */}
                        {/* <Link to={location => (
                            {
                                ...location,
                                pathname: `/upload`,
                                anterior: window.location.pathname || "/unidade",
                            }
                        )}>
                            <button className="btn btn-primary mt-3">Upload</button>
                        </Link> */}

                    </div>
                </div>

                <div className="mt-5">
                    <Tabs defaultActiveKey={"DR"}>

                        {dados[mesSelecionado] && dados[mesSelecionado].map((valor, i) => {

                            let sigla = valor.unidade;
                            let arrayCategorias = [];
                            return (
                                <Tab eventKey={sigla} title={sigla}>
                                    
                                    <Fragment>
                                        <table border="1" className="table table-bordered table-hover table-sm table-striped">
                                            <thead>
                                                <tr>
                                                    <th colSpan="9" className="text-center">{valor.unidade}</th>
                                                </tr>
                                                <tr>
                                                    <th rowSpan="4">Áreas de Atuação</th>
                                                </tr>
                                                <tr>
                                                    <th colSpan="8" className="text-center">STI</th>
                                                </tr>
                                                <tr>
                                                    <th>Realizado (<span style={{textTransform: "uppercase"}}>{mesSelecionado}</span>)</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                
                                                { linhaAtuacao.map((linhaAtuacao, i) => {

                                                    let valorTotalColuna = this.verificaValorTotalCategoria(linhaAtuacao, valor);
                                                    
                                                    return (

                                                        <Fragment>
                                                            <tr className="table caption-top table-primary">
                                                                <td className="text-center">{linhaAtuacao}</td>
                                                                <td>{valorTotalColuna}</td>
                                                            </tr>
                                                            {Object.keys(valor.modalidades).map((modal, j) => {
                                                                let coluna = utils.verificaColuna(modal);
                                                                if(utils.retornaCabecalho(modal) === linhaAtuacao) {
                                                                    return (
                                                                        <Fragment>
                                                                            <tr>
                                                                                <td>{modal}</td>
                                                                                <td>{utils.formataNumero(valor.modalidades[modal][coluna])}</td>
                                                                                {/*
                                                                                <td>{utils.formataNumero(valor.modalidades[modal]["quantidade"])}</td>
                                                                                <td>{utils.formataNumero(valor.modalidades[modal]["horas"])}</td>
                                                                                <td>{utils.formataNumero(valor.modalidades[modal]["calibracao"])}</td>
                                                                                <td>{utils.formataNumero(valor.modalidades[modal]["ensaio"])}</td>
                                                                                <td>{utils.formataNumero(valor.modalidades[modal]["relatorio"])}</td>
                                                                                */}
                                                                            </tr>
                                                                            {
                                                                                modal === "Ensaios" 
                                                                                ?
                                                                                <tr>
                                                                                    <td>{"Relatórios/Laudos"}</td>
                                                                                    <td>{utils.formataNumero(valor.modalidades[modal]["relatoriosELaudos"])}</td>
                                                                                </tr>
                                                                                :
                                                                                null
                                                                            }
                                                                            {
                                                                                modal === "Calibração" 
                                                                                ?
                                                                                <tr>
                                                                                    <td>{"Relatórios/Laudos"}</td>
                                                                                    <td>{utils.formataNumero(valor.modalidades[modal]["relatoriosELaudos"])}</td>
                                                                                </tr>
                                                                                :
                                                                                null
                                                                            }
                                                                        </Fragment>
                                                                    )
                                                                }
                                                                
                                                            })}
                                                        </Fragment>

                                                    )
                                                    
                                                }) }

                                            </tbody>
                                        </table>
                                        
                                        <AnualV2 unidade={sigla} realizados={dadosTransformados} />

                                    </Fragment>

                                </Tab>
                            )
                        })}

                    </Tabs>
                </div>

            </Fragment>
        )
    }
}